import { Instagram, Facebook, Phone, Mail, MessageCircle } from "lucide-react";
import { scrollToId } from "./Navbar";
import { LOGO } from "../data";
import { useContent } from "../content";

export default function Footer() {
  const CONTACT = useContent().contact;
  return (
    <footer id="contact" className="relative overflow-hidden border-t border-white/10 bg-[#050505] pt-24" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 pb-16 lg:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="Logo" className="h-11 w-auto" />
              <span className="flex flex-col leading-none">
                <span className="font-head text-lg font-bold uppercase tracking-tight text-white">Services</span>
                <span className="text-[9px] tracking-[0.25em] text-white/60">EVENT'S MULTITECHNIQUE</span>
              </span>
            </div>
            <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-white/60">
              Maintenance des bâtiments & production événementielle. Une équipe
              multitechnique à votre service.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-white transition-colors hover:border-[#e63946] hover:text-[#ff4d4d]" data-testid="footer-whatsapp" aria-label="WhatsApp">
                <MessageCircle size={18} />
              </a>
              <a href={CONTACT.instagram_url} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-white transition-colors hover:border-[#e63946] hover:text-[#ff4d4d]" data-testid="footer-instagram" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href={CONTACT.facebook_url} target="_blank" rel="noreferrer" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 text-white transition-colors hover:border-[#e63946] hover:text-[#ff4d4d]" data-testid="footer-facebook" aria-label="Facebook">
                <Facebook size={18} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Navigation</h4>
            <ul className="mt-6 space-y-3">
              {[
                { l: "Services", id: "services" },
                { l: "Réalisations", id: "realisations" },
                { l: "Rendez-vous", id: "rdv" },
                { l: "Demander un devis", id: "devis" },
              ].map((x) => (
                <li key={x.id}>
                  <button onClick={() => scrollToId(x.id)} className="text-sm font-light text-white/70 transition-colors hover:text-white" data-testid={`footer-link-${x.id}`}>
                    {x.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">Contact</h4>
            <ul className="mt-6 space-y-4">
              <li>
                <a href={`tel:${CONTACT.phone_raw}`} className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
                  <Phone size={16} className="text-[#ff4d4d]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
                  <Mail size={16} className="text-[#ff4d4d]" /> {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.instagram_url} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
                  <Instagram size={16} className="text-[#ff4d4d]" /> @{CONTACT.instagram}
                </a>
              </li>
              <li>
                <a href={CONTACT.facebook_url} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm text-white/80 transition-colors hover:text-white">
                  <Facebook size={16} className="text-[#ff4d4d]" /> {CONTACT.facebook}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-6 sm:flex-row">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} Event's Multitechnique. Tous droits réservés.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-white/40">Maintenance · Événementiel · Multitechnique</p>
            <a href="/admin/login" className="text-[10px] uppercase tracking-[0.25em] text-white/30 hover:text-[#ff4d4d]" data-testid="footer-admin-link">Admin</a>
          </div>
        </div>
      </div>

      <div aria-hidden className="pointer-events-none select-none overflow-hidden">
        <p className="stroke-text whitespace-nowrap text-center font-head text-[18vw] font-bold uppercase leading-none tracking-tighter">
          SERVICES
        </p>
      </div>
    </footer>
  );
}
